<template>
  <v-card

    class="mx-auto"
  >
    <v-toolbar
      color="teal"
      dark
    >

      <v-toolbar-title>Account Settings</v-toolbar-title>
    </v-toolbar>

   
      <v-subheader>My Donation Form</v-subheader>
      
      <span></span>

      <v-alert
      border="left"
      colored-border
      color="green"
      elevation="2"
    >copy the code snippet below and paste on your webpage's html content, you can adjust the width and height by modifying the width and height attitrube in the iframe code snippet

      <br/>
      <code>{{genHTML()}}</code>
    </v-alert>

    
     <h4> see example below : </h4>
      <iframe 
  width="400"
  height="600"
  frameborder="0" style="border:0"
  :src='source()' allowfullscreen>
</iframe>
     
  </v-card>
</template>

<script>
const fb = require("./../../firebaseconfig");
  export default {
    data: () => ({
      companyName : null,
      npo : null,
      refurbisher : null,
       
    }),
    methods : {
      source(){
        return `https://donation.ecycleforgood.com/donation/${this.npo}/${this.refurbisher}`;
      },
      genHTML(){
        return ` <iframe 
  width="100%"
  height="800"
  frameborder="0" style="border:0"
  src="https://donation.ecycleforgood.com/donation/${this.npo}/${this.refurbisher}" allowfullscreen>
</iframe>`
      }
    },
    mounted() {
        fb.auth.currentUser.getIdTokenResult()
  .then((idTokenResult) => {
    this.npo = idTokenResult.claims.npo;
    this.refurbisher = idTokenResult.claims.id;
  })
    },
  }
</script>